module.exports = __webpack_public_path__ + "img/floor-result-small.db792437.png";